import * as React from 'react';
import { Icon } from '@alifd/next';
import { resetUrl } from '../../common/reset-image';
import MainImage from './main-image';
import * as classnames from "classnames"
import doLog from '../../common/log';
import { useAppSelector } from '../../redux/hooks';
// import { store,EVENT } from '../../store'

const { useState,useEffect,useContext } = React;

interface propTypes {
    mediaItems: [ImageInterface];
    i18n: object;
    clickDialog: ( activeId: number ) => void;
}

export default function MainLayout ( props: propTypes ) {
    const [activeId,setActiveId] = useState( 0 );
    const { mediaItems,clickDialog,i18n } = props;

    const checkSkuActivie = () => {
      const {select} = skuState;
      const {fileName} = select;
      
      if (fileName) {
        mediaItems.filter( ( i,index ) => {
          if ( i.type === 'image' && i.imageUrl.big.indexOf(fileName) > 0 ) {
            setActiveId( index );
          }
        } );
      }
    };
    
    // 监听sku变化导致主图更新
    const skuState = useAppSelector( state => state.sku );
    useEffect(() => {
      checkSkuActivie()
    }, [skuState])


    const renderImage = ( url: string,index: number,type: string ) => {
        const cls = classnames( {
            "main-item": true,
            "active": index === activeId
        } );
        return <div className={cls} key={index} onClick={e => {
            e.preventDefault();
            doLog(
              '/sc.details.commonLogs',
              `action=mainImageThumbClick&info=${index}`
            );
            setActiveId( index );
        }}>
            {type === 'video' && <Icon type="play-fill" size="small" />}
            {type === 'lightCustomModel' && <Icon type="customization" size="small" />}
            {type === 'customModel' && <Icon type="customization" size="small" />}
            {type === 'customHome' && <Icon type="process" size="small" />}
            {( ['video','lightCustomModel','customHome','customModel'].indexOf( type ) !== -1 ) && <div className="mask" />}
            <img loading='lazy' style={{
              height: "48px"
            }} src={resetUrl( url,"100","xz" )} />
        </div>;
    };

    const getUrl = ( item: ImageInterface ) => {
        return item?.cover || item?.videoCoverUrl || item?.imageUrl?.big || item?.customHome?.cover || '//s.alicdn.com/@img/imgextra/i1/O1CN01JN6Qwv25utiKXfKGz_!!6000000007587-0-tps-255-198.jpg';
    };

    // 轻定制/3D支持
    const renderCustom = ( type: string ) => {
        // if ( type === 'video' ) return null;
        if ( type === 'lightCustomModel' || type === 'customModel' ) {
            return <a href="#" onClick={e => {
                e.preventDefault();
                ( document.querySelector( '.customization a' ) as any ).click();
            }}>
                <Icon type="customization" size="xxl" />
                <div className="mask"></div>
                <img className="info" src={resetUrl( getUrl( mediaItems[activeId] ),'350' )} /></a>
        }
        if ( type === 'customHome' ) {
            return <a href={mediaItems[activeId].customHome.url} target="_blank">
                <Icon type="process" size="xxl" />
                <div className="mask"></div>
                <img className="info" src={resetUrl( getUrl( mediaItems[activeId] ),'350' )} /></a>
        }
        return <a href="#" onClick={e => {
            e.preventDefault();
            clickDialog( activeId );
        }}><MainImage src={getUrl( mediaItems[activeId] )} /></a>;
    }

    if ( !mediaItems[activeId] ) return null;

    return (
        <div className="main-layout">
            <div id="prodict-favorite"></div>
            <div className="main-index">
                <div id="main-video" style={{
                    display: mediaItems[activeId].type === "video" ? "" : "none"
                }}></div>
                <div className="image-view">
                    {renderCustom( mediaItems[activeId]?.type )}
                </div>
            </div>
            <div className="main-link" onClick={e => {
                e.preventDefault();
                clickDialog( activeId );
            }}>
                <Icon type="search" size="small" />
                <span>{i18n["widget.detailBoothImage.viewLargerImage"]}</span>
            </div>
            <div className="main-list">
                {mediaItems.slice( 0,7 ).map( ( item,index ) => renderImage( getUrl( item ),index,item.type ) )}
            </div>
            <div id="main-share" />
        </div>
    );
}
